import { motion } from "framer-motion";
import { LogoMark } from "../components/Logo";
import { WORKSPACE_NAV, WORKSPACE_PROJECTS } from "../lib/professionals";
import { fadeUp, viewportOnce } from "../lib/motion";

const WorkspacePanel = () => (
    <section
        id="workspace"
        data-testid="workspace-section"
        className="relative bg-ink py-24 lg:py-36"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    PROFESSIONAL WORKSPACE
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    WS.01
                </p>
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="workspace-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl"
            >
                EVERYTHING IN ONE WORKSPACE
                <span className="text-accent">.</span>
            </motion.h2>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-14"
            >
                <div className="mb-4 flex items-center justify-between font-mono text-[13px] tracking-[0.2em] text-cad">
                    <span>FIG. WS.01 — WORKSPACE OVERVIEW</span>
                    <span>1 : 1</span>
                </div>

                <div
                    data-testid="workspace-panel"
                    className="border border-white/15 bg-[#0C1428] shadow-[0_32px_80px_rgba(0,0,0,0.5)]"
                >
                    <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
                        <span className="flex items-center gap-3">
                            <LogoMark className="h-5 w-5" />
                            <span className="font-mono text-[13px] tracking-[0.22em] text-mist">
                                BUILDEASE — PROFESSIONAL WORKSPACE
                            </span>
                        </span>
                        <span className="border border-accent/60 px-2.5 py-1 font-mono text-[13px] tracking-[0.22em] text-accent">
                            SAMPLE UI
                        </span>
                    </div>

                    <div className="grid md:grid-cols-12">
                        <div className="border-b border-white/10 p-4 md:col-span-3 md:border-b-0 md:border-r">
                            {WORKSPACE_NAV.map((item) => (
                                <div
                                    key={item.label}
                                    data-testid={`workspace-nav-${item.label
                                        .toLowerCase()
                                        .replace(/\s+/g, "-")}`}
                                    aria-current={item.active ? "page" : undefined}
                                    className={`flex items-center gap-3 border-l-2 px-4 py-3 text-[15px] tracking-wide transition-colors duration-300 ${
                                        item.active
                                            ? "border-accent bg-white/[0.05] text-accent"
                                            : "border-transparent text-mist"
                                    }`}
                                >
                                    <item.icon
                                        className="h-4 w-4"
                                        aria-hidden="true"
                                    />
                                    {item.label}
                                </div>
                            ))}
                        </div>

                        <div className="p-6 md:col-span-9 md:p-8">
                            <div className="flex items-center justify-between">
                                <h3 className="font-display text-lg font-semibold tracking-tight text-white">
                                    PROJECTS
                                </h3>
                                <p className="font-mono text-[13px] tracking-[0.2em] text-cad">
                                    03 LISTED
                                </p>
                            </div>
                            <div className="mt-5 space-y-3">
                                {WORKSPACE_PROJECTS.map((p) => (
                                    <div
                                        key={p.name}
                                        data-testid={`workspace-project-${p.stage.toLowerCase()}`}
                                        className="flex flex-wrap items-center justify-between gap-x-4 border border-white/10 px-5 py-4 transition-colors duration-300 hover:bg-white/[0.03]"
                                    >
                                        <div>
                                            <p className="text-[15px] text-white">
                                                {p.name}
                                            </p>
                                            <p className="mt-1 font-mono text-[13px] tracking-[0.18em] text-cad">
                                                {p.location}
                                            </p>
                                        </div>
                                        <span
                                            className={`px-3 py-1.5 font-mono text-[13px] tracking-[0.22em] ${
                                                p.accent
                                                    ? "border border-accent/70 text-accent"
                                                    : "border border-white/25 text-white/80"
                                            }`}
                                        >
                                            {p.stage}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <p className="border-t border-white/10 px-5 py-4 font-mono text-[13px] tracking-[0.2em] text-mist">
                        CONCEPTUAL INTERFACE — ILLUSTRATIVE DATA ONLY
                    </p>
                </div>
            </motion.div>
        </div>
    </section>
);

export default WorkspacePanel;
